import React from "react";
import {ChatWidget} from "../components/ChatBot/ChatWidget";

function ChatBotPage() {
  return (
    <>
      <ChatWidget />
    </>
  );
}

export default ChatBotPage;
